const ASSISTANT_PANEL_SELECTOR = '[data-assistant-panel]';
const SEARCH_FIELD_SELECTOR = 'input[type="search"], [role="searchbox"]';

export function isPageEditEvent(event: Event): boolean {
  const target = event.target;
  if (!(target instanceof Element)) {
    return false;
  }
  if (target.closest(ASSISTANT_PANEL_SELECTOR) !== null) {
    return false;
  }
  return target.matches(SEARCH_FIELD_SELECTOR) === false;
}
